/**
 * @generated SignedSource<<89fbf5da8de88c14e0a95b850f10e40f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type searchCategoryQuery$variables = {
  provider: ProductProvider;
};
export type searchCategoryQuery$data = {
  readonly providerCategories: ReadonlyArray<{
    readonly categories: ReadonlyArray<{
      readonly categoryID: number;
      readonly name: string;
    }>;
    readonly macroCategoryID: number;
    readonly name: string;
  }>;
};
export type searchCategoryQuery = {
  response: searchCategoryQuery$data;
  variables: searchCategoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "provider"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "provider",
        "variableName": "provider"
      }
    ],
    "concreteType": "ProductProviderMacroCategory",
    "kind": "LinkedField",
    "name": "providerCategories",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "macroCategoryID",
        "storageKey": null
      },
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductProviderCategory",
        "kind": "LinkedField",
        "name": "categories",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "categoryID",
            "storageKey": null
          },
          (v1/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "searchCategoryQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "searchCategoryQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "835e1f23481dbde20f33b071a0d6d63d",
    "id": null,
    "metadata": {},
    "name": "searchCategoryQuery",
    "operationKind": "query",
    "text": "query searchCategoryQuery(\n  $provider: ProductProvider!\n) {\n  providerCategories(provider: $provider) {\n    macroCategoryID\n    name\n    categories {\n      categoryID\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "85f86bddcb2a2640d21620b147c471fc";

export default node;
